import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import MasterStaffRouterSearchComponent from "../components/master-staff/MasterStaffRouterSearchComponent";

const RouterSearchPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Search Router"
        routes={[{ title: "Home", path: "/" }]}
      />
      <MasterStaffRouterSearchComponent />
    </>
  );
};
export default RouterSearchPage;
